<template>
  <generic-modal :modal-key="'confirm_purchase_via_sms'" :has-extra-modal-class="'store_popup_box purchase modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
        <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
        <img src="static/images/store/photo-confirm.png" class="op_down_img">
          <p>
            <b>
              {{ getBundleData.numberOfGames ? getBundleData.numberOfGames + ' ' + getTranslations.home_modals_confirm_purchase_games:'' }}
              {{getBundleData.numberOfGames && getBundleData.points?getTranslations.home_modals_confirm_purchase_successfull_and :''}}
              {{ getBundleData.points ? getBundleData.points + ' ' + getTranslations.home_store_points : '' }}
              – {{ getBundleData.price}} {{ getBundleData.currencyCode }}
            </b>
          </p>
          <p>{{ getTranslations.home_modals_confirm_purchase_via_sms_playing_more }}</p>
          <p>{{ getTranslations.home_modals_confirm_purchase_via_sms_purchase_now_by }}</p>
    </template>
  </generic-modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters } from 'vuex';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'confirmPurchaseViaSms',
  components: { GenericModal },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseViaSms.vue